<label class="label" for="{{fieldId}}">
    <input class="form-control floating-input" placeholder=" " type="number" (input)="selectedCurrencyValue()" [(ngModel)]="selectedValue" min="0"
        max="10000000000" [ngClass]="{'is-invalid': invalid}"/>
    <span class="highlight"></span>
    <label class="effect-label">{{myLabel}}</label>
</label>

<select class="currency-dropdown" [(ngModel)]="selectedCurrency" (change)="selectedCurrencyValue()">
    <option *ngFor="let currency of currencyCodes" [ngValue]="currency" [selected]="currency.code == 'gbp'">
        {{currency.display}}
    </option>
</select>
